import { render, staticRenderFns } from "./ProfileVetted.vue?vue&type=template&id=4bdbb657&"
import script from "./ProfileVetted.vue?vue&type=script&lang=js&"
export * from "./ProfileVetted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports